import React, { useState } from 'react';
import RecordHistory from './RecordHistory';
import InvoiceManager from './InvoiceManager';
import BudgetHistory from './BudgetHistory';
import { FileText, Receipt, FileCheck } from 'lucide-react';

type TabType = 'records' | 'invoices' | 'budgets';

const HistoryManager: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabType>('records');

  const tabs = [
    {
      id: 'records' as TabType,
      label: 'Historiales Médicos',
      icon: FileText,
      component: RecordHistory,
    },
    {
      id: 'invoices' as TabType,
      label: 'Facturas',
      icon: Receipt,
      component: InvoiceManager,
    },
    {
      id: 'budgets' as TabType,
      label: 'Presupuestos',
      icon: FileCheck,
      component: BudgetHistory,
    },
  ];

  const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component || RecordHistory;

  return (
    <div className="max-w-7xl mx-auto">
      <div className="bg-white rounded-2xl shadow-soft overflow-hidden">
        {/* Header con pestañas */}
        <div className="bg-gradient-to-r from-pastel-blue to-pastel-blue-light px-8 py-6">
          <div className="flex items-center space-x-3 mb-6">
            <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center shadow-gentle">
              <FileText className="h-6 w-6 text-primary-700" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-primary-700">Historial</h1>
              <p className="text-primary-600 text-sm">
                Gestiona tus historiales médicos, facturas y presupuestos
              </p>
            </div>
          </div>

          {/* Pestañas */}
          <div className="flex space-x-2 border-b border-white/20">
            {tabs.map(tab => {
              const Icon = tab.icon;
              const isActive = activeTab === tab.id;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`flex items-center space-x-2 px-6 py-3 font-medium transition-all duration-200 border-b-2 ${
                    isActive
                      ? 'border-white text-white bg-white/20'
                      : 'border-transparent text-primary-600 hover:text-white hover:bg-white/10'
                  }`}
                >
                  <Icon className="h-5 w-5" />
                  <span>{tab.label}</span>
                </button>
              );
            })}
          </div>
        </div>

        {/* Contenido de la pestaña activa */}
        <div>
          <ActiveComponent />
        </div>
      </div>
    </div>
  );
};

export default HistoryManager;

